import { Injectable } from '@angular/core';
import { Route } from '@core/routing/routes/enums/route';
import { Observable, of } from 'rxjs';
import { isNil } from '@core/utils/nil/is-nil';

@Injectable({
  providedIn: 'root',
})
export class RouteTitleProvider {
  private readonly entries = new Map<Route, string>([
    [Route.SignIn, 'Logowanie'],
    [Route.RecoverPassword, 'Odzyskaj hasło'],
    [Route.ResetPassword, 'Zresetuj hasło'],
    [Route.Users, 'Użytkownicy'],
    [Route.UserUpdate, 'Edytuj użytkownika'],
    [Route.UserLoyaltyAccount, 'Szczegóły konta lojalnościowego'],
    [Route.UserPaymentHistory, 'Historia płatności'],
    [Route.CarWashes, 'Myjnie'],
    [Route.CarWashDetails, 'Szczegóły myjni'],
    [Route.CarWashCreate, 'Dodaj myjnię'],
    [Route.CarWashUpdate, 'Edytuj myjnię'],
    [Route.Settings, 'Ustawienia'],
  ]);

  entry(route: Route): Observable<string> {
    const entry = this.entries.get(route);

    if (isNil(entry)) {
      const key = Route[route];

      throw new Error(`The route title "${key}" not found.`);
    }

    return of(entry);
  }
}
